module.exports = __webpack_public_path__ + "static/media/logo-p-500-white.2197f222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-p-500-white.png
// module id = 1104
// module chunks = 0